<template>
 <div>
   <div class="p-fluid p-formgrid p-grid">
     <div class="p-field p-col-12 p-md-9"></div>
     <div class="p-field p-col-12 p-md-1">
      <Button class="p-button-raised btn" @click="generateReport" label="Print"
      icon="pi pi-print"/>
       <Button class="p-button-raised btn" @click="generateReport" label="Print QOT"
      icon="pi pi-print"/>
     </div>
    <div class="p-field p-col-12 p-md-1">
      <Button class="p-button-raised p-button-danger btn" @click.prevent="$router.back()" label="Cancel"/>
    </div>
  </div>
    <Card>
      <template #content>
        <div class="p-grid">
          <div class="p-col-4"></div>
          <div class="p-col-4">
            <img :src="$store.state.organisationLogo" style="text-align:center" alt="Logo"
            class="img-responsive center-block logo">
          </div>
          <div class="p-col-4"></div>
      </div>
     <div class="p-grid">
       <div class="p-col-1"></div>
       <div class="p-col-10">
         <h5 style="text-align:-webkit-center;font-size:18px">{{organisationName}}</h5>
         <h5 style="text-align:-webkit-center;margin-top: -8px;">{{organisationAddress}}</h5>
         <h5 style="text-align:-webkit-center;margin-top: -8px;">{{organisationContact}}</h5>
         <h5 style="text-align:-webkit-center;margin-top: -8px;">Pan No: {{organisationPanNo}}</h5>
         <h5 style="text-align:-webkit-center;margin-top: -8px;">QOT</h5>
       </div>
       <div class="p-col-1"></div>
     </div>
     <div class="p-grid">
       <div class="p-col-6">
        <span>Name:{{customerName}}</span><br/>
        <span>Contact:{{customerNumber}}</span>
       </div>
       <!-- <div class="p-col-6 p-ml-1">
       </div> -->
       <div class="p-col-6" >
         <span for="fromDate" style="float:right">Date: {{nepaliDate}}</span><br/>
         <span for="fromDate" style="float:right">Bill No: {{billNo}}</span>
       </div>
       <!-- <div class="p-col-6 p-ml-1">
       </div> -->
     </div>
     <table class="table table-bordered" >
       <thead style="padding: 4px; font-size: 10px;">
         <tr>
           <th style="text-align:center;">S.n</th>
           <th style="text-align:center;">Particular</th>
           <th style="text-align:center">Qty</th>
        </tr>
       </thead>
       <tbody v-for="(item,index) in salesList " :key="index">
         <tr>
           <td>{{index+1}}</td>
           <td>{{item.itemName}}</td>
           <td style="text-align:right">{{item.quantity}}</td>
         </tr>
       </tbody>
     </table>
     <div class="p-col-12">
       <span style="float:right">Received By: {{receivedBy}}</span>
     </div>
     </template>
  </Card>

</div>
</template>
<script>
import Button from 'primevue/button'
import Card from 'primevue/card'
export default {
  name: 'qotPrintPage',
  props: ['printData'],
  data() {
    return {
      organisationName: '',
      organisationAddress: '',
      organisationContact: '',
      organisationPanNo: '',
      customerName: '',
      customerNumber: '',
      billNo: '',
      // englishDate: null,
      nepaliDate: null,
      salesList: [],
      narration: '',
      subTotalAmount: 0.0,
      discountAmt: 0.0,
      vatPercentage: 0.0,
      vatAmount: 0.0,
      billAmount: 0.0,
      tenderAmount: 0.0,
      returnedAmount: 0.0,
      amountInWords: '',
      totalQty: 0,
      totalSubTotal: 0,
      receivedBy: ''
    }
  },
  mounted () {
    this.openVoucherDialog()
  },
  computed: {
  },
  methods: {
    async openVoucherDialog() {
      if (this.printData === undefined) {
        this.$router.back()
        return
      }
      this.organisationName = this.$store.state.organisationName
      this.organisationAddress = this.$store.state.organisationAddress
      this.organisationContact = this.$store.state.organisationContact
      this.organisationPanNo = this.$store.state.organisationPanVatNo
      this.organisationLogo = this.$store.state.organisationLogo
      this.receivedBy = this.$store.state.user.name
      // // debugger
      this.salesList = this.printData.childSalesDetailsDTOList
      this.nepaliDate = this.printData.salesDateNepali
      this.customerName = this.printData.customerName
      this.customerNumber = this.printData.contactNumber
      this.tenderAmount = this.printData.tenderAmount
      this.returnedAmount = this.printData.returningAmount
      this.billAmount = this.printData.billAmount
      this.vatPercentage = this.printData.vatPercentage
      this.vatAmount = this.printData.vatAmount
      this.discountAmt = this.printData.discountAmount
      this.amountInWords = this.printData.amountInWords
      this.billNo = this.printData.billPrefix
      this.subTotalAmount = this.printData.subTotalAmount
      this.findTotalQty()
    },
    findTotalQty() {
      this.totalQty = 0
      for (let i = 0; i < this.salesList.length; i++) {
        this.totalQty += this.salesList[i].quantity
        this.totalSubTotal += parseFloat(this.salesList[i].quantity) * parseFloat(this.salesList[i].sellingPrice)
      }
    },
    generateReport () {
      window.print()
    }
  },
  components: {
    Button,
    Card
  }
}
</script>
<style scoped >
@media print {
    .btn {
      display: none !important;
    }
}
</style>



// WEBPACK FOOTER //
// qotPrintPage.vue?1d256422